<template>
	<Collapsible
    v-if="menusEnhanced.length"
    class="location-box__menues"
    :initial-open="false"
  >
    <template slot="trigger">
      <div class="location-box__menues-trigger">
        <SVGMenu class="location-box__menues-trigger-icon"/>
        <span
          class="location-box__menues-trigger-text"
          v-html="$t('locations.menuTrigger')"
        />
      </div>
    </template>
    <div class="location-box__menues-links">
      <Button
        v-for="(menu, index) in menusEnhanced"
        :key="index"
        :href="menu.url"
        :target="menu.target"
        :text="menu.name"
        level="tertiary"
        arrow
      />
    </div>
  </Collapsible>
</template>

<script>
import { mapGetters } from 'vuex';
import Button from '@/components/Button';
import Collapsible from '@/components/Collapsible';

export default {
	components: {
		Button,
		Collapsible,
	},
	data() {
		return {
			id: this.$root.options.id,
			code: this.$root.options.code,
      menus: this.$root.options.menus || [],
		};
	},
	computed: {
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
    menusEnhanced() {
      return this.menus
        .filter(menu => menu.featureFlag ? this.hasFeature(menu.featureFlag) : true)
    }
	},
	methods: {

	}
}
</script>

<style>

</style>
